import { render } from "./HouseBottomNewMail.vue?vue&type=template&id=187fcd46"
import script from "./HouseBottomNewMail.vue?vue&type=script&lang=js"
export * from "./HouseBottomNewMail.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__